export const DEFAULT_CIGS_SMOKED_DAILY = 20;
export const DEFAULT_PACK_PRICE = 5.5;
export const DEFAULT_CIGS_IN_A_PACK = 20;
export const NUMBER_OF_DAYS_IN_A_YEAR = 365;
export const NUMBER_OF_PODS_PER_PACK = 4;



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/appConstants.js